import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../Common/CardWrap";
import { userServices } from "../../Services/user.service";
import { useTranslation } from "react-i18next";
import { apiUrl } from "../../Config/Url";
import StoresTab from "../Tab/StoresTab";
import TenantsTab from "../Tab/TenantsTab";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { Tabs, Tab } from "react-bootstrap";

export default function UserDetail(props) {
  let id = props.match.params.userId;
  const {
    updateLocName,
    updateLocUser,
    locTab,
    locName,
    locTenant,
    locStore,
    updateLocTab,
    updateLocKey,
  } = useContext(GlobalContext);
  const [key, setKey] = useState("tenants");
  const { t: translator } = useTranslation();
  const history = useHistory();
  const [isLoaded, setIsLoaded] = useState(false);
  const [backUrl, setBackUrl] = useState();
  const [user, setUser] = useState({
    userId: id,
    isActive: true,
    loginName: "",
    realName: "",
    printName: "",
    personalIdentificationNumber: "",
    phone: "",
    email: "",
    pin: "",
    roleId: "",
  });
  const [message, setMessage] = useState("");
  useEffect(() => {
    switch (locName) {
      case "tenants":
        setBackUrl(`/${locName}/${locTenant}`);
        break;
      case "stores":
        setBackUrl(`/${locName}/${locStore}`);
        break;
      default:
        setBackUrl(`/${locName}`);
    }
    userServices
      .getById(id)
      .then((res) => {
        if (res.status === 200) {
          setIsLoaded(true);
          setUser(res.data);
        } else history.push("/not-found");
      })
      .catch((err) => {
        console.log("error", err);
        setMessage(err);
      });

    if (locTab != null && locTab != 0) {
      setKey(locTab);
    } else {
      setKey("tenants");
      updateLocTab("tenants");
    }

    updateLocName("users");
    updateLocUser(id);
    updateLocKey(id);
  }, []);

  const handleCancle = () => {
    history.push("/users");
  };

  const updateUser = () => {
    history.push("/update-user/" + id);
  };

  return (
    <CardWrap
      subtitle={translator("User-UserDetail-Subtitle")}
      backUrl={backUrl}
    >
      <h1>{translator(message)}</h1>
      <div className="row pl-0">
        <div className="col-lg-3">
          <div className="custom-card m-2">
            <div className="custom-card-header">
              <h3>
                {user.realName}{" "}
                <span className="button-edit">
                  {" "}
                  <span
                    onClick={updateUser}
                    title={translator("PosDetail-EditIcon-Title")}
                    className="icon icon-edit"
                  ></span>
                </span>
              </h3>
              <span className="custom-card-subtitle">
                <strong>{translator("User-UserDetail-OIB")}:</strong>{" "}
                {user.personalIdentificationNumber}
              </span>
              <hr />
            </div>
            <div className="custom-card-body">
              <p>
                <span>
                  <strong>Email:</strong> {user.email}
                </span>
                <br />
                <span>
                  <strong>{translator("User-UserDetail-PhoneNumber")}:</strong>{" "}
                  {user.phone}
                </span>
              </p>
              <hr />
              <p>
                <span>
                  <strong>{translator("User-UserDetail-UserName")}:</strong>{" "}
                  {user.loginName}
                </span>
                <br />
                <span>
                  <strong>{translator("User-UserDetail-PrintName")}</strong>{" "}
                  {user.printName}
                </span>
                <br />
                <span>
                  <strong>Pin:</strong> ****{" "}
                </span>
                <br />
                <span>
                  <strong>{translator("User-UserDetail-Role")}:</strong>{" "}
                  {translator(user.roleName)}{" "}
                </span>
                <br />
              </p>
            </div>
            <div className="custom-card-footer"></div>
          </div>
        </div>
        <div className="col-lg-9 border-left">
          {isLoaded && (
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => {
                setKey(k);
                updateLocTab(k);
              }}
            >
              {" "}
              <Tab
                style={{ marginLeft: "-18px" }}
                eventKey="tenants"
                title={translator("User-UserDetail-NavTitle-Tenants")}
                tabClassName="mob-tabs"
              >
                <TenantsTab url={`${apiUrl}/user/${id}/tenants`} userId={id} />
              </Tab>
              <Tab
                eventKey="stores"
                title={translator("User-UserDetail-NavTitle-Stores")}
                tabClassName="mob-tabs"
              >
                <StoresTab
                  url={`${apiUrl}/user/${id}/stores`}
                  tenantId={false}
                  userId={id}
                />
              </Tab>
            </Tabs>
          )}
        </div>
      </div>
      <div
        className="container-fluid"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <button className="btn btn-outline-secondary" onClick={handleCancle}>
          {translator("User-UserDetail-BtnBack")}
        </button>
      </div>
    </CardWrap>
  );
}
